import { UserRoles } from '@/enums';
import { Clients } from '@/modules/clients/types';
import { all_internal_roles } from '@/utils';

const access_roles = {
  [Clients.Pages.CLIENTS]: all_internal_roles,
  [Clients.Pages.CLIENT_DETAIL]: all_internal_roles,
  [Clients.Pages.CLIENT_EDIT]: [
    UserRoles.Internal.PARTNER_MANAGER,
    UserRoles.Internal.VICE_PARTNER_MANAGER,
    UserRoles.Internal.PURCHASING_MANAGER,
    UserRoles.Internal.SALE_MANAGER,
    UserRoles.Internal.SALE_MANAGER_FULL_PRICE,
    UserRoles.Internal.SERVICE_MANAGER,
  ],
};

export default access_roles;
